/**
 * Слой C паритета SSR/CSR (ТЗ SEO-8 §6.10) — страховка на `{path: '**'}`.
 *
 * После слоя A (перезапись до старта роутера) legacy-путь может дойти до роутера
 * только внутренней SPA-навигацией, то есть если в §5.5 забыли литерал. Guard
 * превращает такой недосмотр из 404 в работающую страницу.
 *
 * **`console.warn` в dev обязателен.** Без него guard маскирует забытый литерал:
 * экран работает, дефект невидим, и §5.5 считается выполненным, хотя нет. Тот же
 * лог закрывает риск §9 «значения `menu.uri` на проде отличаются от демо-фикстуры».
 *
 * Решение о редиректе — в `legacy-url-map.resolveLegacyRedirect` (чистая функция,
 * там же и спека). Здесь только адаптер: `environment` тут импортировать НЕЛЬЗЯ —
 * он тянет barrel `compob2b-libs` и ломает node-env спеки; `isDevMode()` из
 * `@angular/core` даёт то же самое (его переключает `enableProdMode()` в `main.ts`).
 */
import {inject, isDevMode} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {resolveLegacyRedirect} from './legacy-url-map';

export const legacyUrlGuard: CanActivateFn = (_route, state) => {
  const next = resolveLegacyRedirect(state.url);
  if (next === null) {
    return true;
  }

  if (isDevMode()) {
    // Не `console.error`: это не поломка рантайма, а недоделка миграции.
    console.warn(
      `[legacy-url] в приложении осталась legacy-ссылка: ${state.url} → ${next}. `
      + 'Guard увёл на новый путь, но литерал надо починить в источнике (ТЗ §5.5).',
    );
  }

  return inject(Router).parseUrl(next);
};
